
import { createContext } from 'react';
import type { Language } from '../types';

export interface LocalizationContextType {
  language: Language;
  culture: string;
  currency: string;
  nationality: string;
  setLanguage: (lang: Language) => void;
}

export const getLocalizationDefaults = (lang: Language) => {
  switch (lang) {
    case 'da': return { culture: 'da-DK', currency: 'DKK', nationality: 'DK' };
    case 'en': return { culture: 'en-US', currency: 'EUR', nationality: 'SE' };
    case 'sv':
    default: return { culture: 'sv-SE', currency: 'SEK', nationality: 'SE' };
  }
};

const defaults = getLocalizationDefaults('sv');

export const LocalizationContext = createContext<LocalizationContextType>({
  language: 'sv',
  ...defaults,
  setLanguage: () => {},
});
